import React from "react";
import { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import star from "../../assets/images/sarees/star.png";
import sareeImg1 from "../../assets/images/sarees/saree-img1.png";
import sareeImg2 from "../../assets/images/sarees/saree-img2.png";
import { FaStar } from "react-icons/fa";
import { FaGripLinesVertical } from "react-icons/fa";
import { Mail } from "../../components/Mailbox";
import Carousel from "react-bootstrap/Carousel";
import sliderImg1 from "../../assets/images/saree-subCategory/slider-img1.png";
import sliderImg2 from "../../assets/images/saree-subCategory/slider-img2.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useDispatch } from "react-redux";
import { addToCart } from "../../appRedux/actions-reducer";
import Modal from "react-bootstrap/Modal";
import successImg from "../../assets/images/sarees/successImg.png";
import { FaRegHeart } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";

export function SareeSubCategory() {
  const navigate = useNavigate();
  const location = useLocation();
  const { Details } = location.state || {};
  const [currentProduct, setCurrentProduct] = useState(Details); //storing Details here

  const [products, setProducts] = useState([]);
  const [wishlistDisabled, setWishlistDisabled] = useState(false);
  // const [carddata, setData] = useState([]);
  // modal state
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  async function addtoCart(id) {
    const userId = localStorage.getItem("user_id");
    const Id = id;
    const requestData = {
      userId: userId,
      clothingId: Id,
      quantity: 1,
    };
    try {
      const response = await axiosInstance.post(`/addtocart`, requestData);
      if (response.data.status === 200) {
        toast.success(response.data.message || "Added Successfully");
      } else {
        toast.error("Something went wrong, please try again!");
      }
    } catch (error) {
      console.error("Submission failed:", error);
      toast.error("Submission failed! Please try again.");
    }
  }
  async function handlewishlistClick(e, product) {
    e.stopPropagation();

    const userId = localStorage.getItem("user_id");
    if (wishlistDisabled) return;

    setWishlistDisabled(true); // disable rapid toggling

    try {
      if (product.in_wishlist === 0) {
        // Add to wishlist
        const res = await axiosInstance.post("/admin/insertWishlist", {
          clothing_id: product.id,
          user_id: userId,
        });

        if (res.status === 200) {
          toast.success(res.data.message || "Added to wishlist");

          // Update UI
          setProducts((prev) =>
            prev.map((p) =>
              p.id === product.id ? { ...p, in_wishlist: 1 } : p
            )
          );
        } else {
          toast.error("Something went wrong while adding to wishlist.");
        }
      } else {
        // Remove from wishlist
        const res = await axiosInstance.delete(
          `/admin/deletewishlist/${product.w_id}`
        );

        if (res.status === 200) {
          toast.success(res.data.data || "Removed from wishlist");

          // Update UI
          setProducts((prev) =>
            prev.map((p) =>
              p.id === product.id ? { ...p, in_wishlist: 0 } : p
            )
          );
        } else {
          toast.error("Something went wrong while removing from wishlist.");
        }
      }
    } catch (error) {
      console.error("Wishlist error:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      // Re-enable after short delay
      setTimeout(() => setWishlistDisabled(false), 500);
    }
  }

  async function LoadProducts() {
    const RequestMethod = {
      type: "1",
      price_min: "",
      price_max: "",
      availability: "",
      pageNo: 1,
      user_id: localStorage.getItem("user_id") || 0,
    };

    try {
      const response = await axiosInstance.post(
        "/clothingByType",
        RequestMethod
      );
      console.log("saree data", response.data);

      const filteredData = response.data.data.filter(
        (item) => item.active_flag === "A"
      );
      console.log("filtered data", filteredData);

      // Set filtered data to state
      setProducts(filteredData || []);
    } catch (error) {
      console.error("Error loading products:", error);
    }
  }
  useEffect(() => {
    LoadProducts();
  }, []);
  const [desc] = useState(
    currentProduct.cloth_description ? currentProduct.cloth_description : "---"
  );
  const [disc] = useState(
    currentProduct.disclaimer ? currentProduct.disclaimer : "---"
  );
  const [shop] = useState(
    currentProduct.shopping ? currentProduct.shopping : "---"
  );
  const [ret] = useState(
    currentProduct.return_policy ? currentProduct.return_policy : "---"
  );
  const [customer, setCustomer] = useState([]);
  const [menu, setMenu] = useState(desc);

  var customerReviews = [
    {
      rate: 4.5,
      desc: "The quality is really good as its mentioned and the colour is also  perfect and easy to carry . The cloth of blouse is attached with it and  material is also top notch.",
      name: "Ravi Kumar",
      date: "4 Jan 2025",
    },
    {
      rate: 4.5,
      desc: "The quality is really good as its mentioned and the colour is also  perfect and easy to carry . The cloth of blouse is attached with it and  material is also top notch.",
      name: "Ravi Kumar",
      date: "4 Jan 2025",
    },
    {
      rate: 4.5,
      desc: "The quality is really good as its mentioned and the colour is also  perfect and easy to carry . The cloth of blouse is attached with it and  material is also top notch.",
      name: "Ravi Kumar",
      date: "4 Jan 2025",
    },
  ];

  function CustomerReview() {
    setCustomer(customerReviews);
  }
  function handleMenu(data) {
    setMenu(data);
  }

  useEffect(() => {
    console.log("sareedetailsid", currentProduct?.id);
    CustomerReview();
  }, []);

  // Whenever Details.id changes (i.e. new product is clicked), scroll to the top
  useEffect(() => {
    if (currentProduct?.id) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [currentProduct?.id]); //watches for Details update

  return (
    <>
      {/* <ToastContainer/> */}
      <div className="container HomeMainContainer">
        <Breadcrumb className="custom-breadcrumb">
          <Breadcrumb.Item href="/">HOME</Breadcrumb.Item>
          <Breadcrumb.Item href="/saree">SAREES</Breadcrumb.Item>
          <Breadcrumb.Item>PRODUCT NAME</Breadcrumb.Item>
        </Breadcrumb>
        {/* slider images */}

        <div className="main-container">
          <div className="slider-container">
            <div className="custome-carousel">
              {/* carousel for showing only images exist */}
              {(() => {
                const imageList = [
                  currentProduct?.image,
                  currentProduct?.image_two,
                  currentProduct?.image_three,
                  currentProduct?.image_four,
                ].filter(
                  (img) =>
                    img &&
                    img.trim() !== "" &&
                    img.trim().toLowerCase() !== "null"
                );

                return imageList.length > 0 ? (
                  <Carousel indicators={true}>
                    {imageList.map((img, idx) => (
                      <Carousel.Item key={idx} interval={1000}>
                        <img
                          src={img}
                          alt={`productImage-${idx}`}
                          style={{ borderRadius: "8px" }}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : null;
              })()}
            </div>
          </div>
          <div className="text-container">
            <div>
              <div>
                <div className="d-flex justify-content-between">
                  <div className="product-title">
                    {currentProduct.product_name}
                  </div>

                  <div
                    onClick={(e) => {
                      if (!wishlistDisabled) {
                        handlewishlistClick(e, currentProduct);
                      }
                    }}
                    style={{
                      cursor: wishlistDisabled ? "not-allowed" : "pointer",
                      opacity: wishlistDisabled ? 0.5 : 1,
                    }}
                  >
                    {currentProduct.in_wishlist === 1 ? (
                      <FaHeart className="wishlist-heart-sareeSub" />
                    ) : (
                      <FaRegHeart className="wishlist-heart-sareeSub" />
                    )}
                  </div>
                </div>

                <div>
                  <span className="product-price">
                    ₹ {currentProduct.price}
                  </span>
                  <span className="product-mrp">
                    MRP<strike> </strike>
                    {currentProduct.mrp ? currentProduct.mrp : "- - -"}
                  </span>
                  <span className="product-off">
                    (₹{currentProduct.discount} OFF)
                  </span>
                </div>
                <div className="rate-container">
                  <span className="customer-star">
                    <FaStar />
                  </span>
                  <span>{currentProduct.average_rating}</span>
                  <span style={{ color: "gray" }}>
                    <FaGripLinesVertical />
                  </span>
                  <span>
                    {currentProduct.rating ? currentProduct.rating : "--"}{" "}
                    Ratings
                  </span>
                </div>
              </div>
            </div>
            <div className="menuitem-container">
              <span
                className={menu === desc ? "active" : ""}
                onClick={() => handleMenu(desc)}
              >
                Description
              </span>
              <span
                className={menu === disc ? "active" : ""}
                onClick={() => handleMenu(disc)}
              >
                Disclaimer
              </span>
              <span
                className={menu === shop ? "active" : ""}
                onClick={() => handleMenu(shop)}
              >
                Shopping
              </span>
              <span
                className={menu === ret ? "active" : ""}
                onClick={() => handleMenu(ret)}
              >
                Return Policy
              </span>
            </div>
            <div className="menu-content">{menu}</div>
            <div>
              <div className="quantity-text">Quantity</div>
              <div className="count">
                <button className="btn">-</button>
                <span>1</span>
                <button className="btn">+</button>
              </div>
            </div>
            <div className="text-btnContainer">
              <button className="btnBuy">
                <Link
                  to="/checkout"
                  style={{ textDecoration: "none", color: "#c9067b" }}
                >
                  Buy Now
                </Link>
              </button>
              <button
                className="btnAdd"
                onClick={() => {
                  const token = localStorage.getItem("token");

                  if (token) {
                    handleShow();
                    addtoCart(currentProduct.id);
                  } else {
                    navigate("/login");
                  }
                }}
              >
                Add To Cart
              </button>
            </div>
          </div>
        </div>

        {/* cards-part */}
        <div className="subcard-title">You May Also Like</div>
        <div className=" subcategory-cards-part">
          <div className="subcategory-cards">
            {products.map((product) => (
              <div className="saree-sub-card" key={product.id}>
                <div
                  className="saree-card-image"
                  style={{
                    backgroundImage: `url(${product.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "90%",
                    transition: "background-image 0.3s ease-in-out",
                    position: "relative",
                    borderRadius: "8px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundImage = `url(${product.image_two})`;
                    e.currentTarget.querySelector(
                      ".saree-btnContainer"
                    ).style.display = "flex";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundImage = `url(${product.image})`;
                    e.currentTarget.querySelector(
                      ".saree-btnContainer"
                    ).style.display = "none";
                  }}
                  // onClick={() => {
                  //   navigate("/sareesubcategory", {
                  //     state: {
                  //       Details: product,
                  //       // isWishlisted: wishlistedItems[product.id] || false,
                  //     },

                  //   });
                  // }}
                  onClick={() => {
                    setCurrentProduct(product);
                    navigate("/sareesubcategory");
                  }}
                >
                  <div className="saree-btnContainer">
                    <button
                      className="sree-hoverBtn"
                      onClick={(e) => {
                        e.stopPropagation();

                        const token = localStorage.getItem("token");

                        if (token) {
                          handleShow();
                          addtoCart(product.id);
                        } else {
                          navigate("/login");
                        }
                      }}
                    >
                      Add To Cart
                    </button>
                  </div>

                  {/* <div onClick={(e) => handlewishlistClick(e, product)}>
                            {product.in_wishlist === 1 ? (
                              <FaHeart className="wishlist-heart" />
                            ) : (
                              <FaRegHeart className="wishlist-heart" />
                            )}
                          </div> */}
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      const token = localStorage.getItem("token");

                      if (!wishlistDisabled) {
                        if (token) {
                          handlewishlistClick(e, product);
                        } else {
                          navigate("/login");
                        }
                      }
                    }}
                    style={{
                      cursor: wishlistDisabled ? "not-allowed" : "pointer",
                      opacity: wishlistDisabled ? 0.5 : 1,
                    }}
                  >
                    {product.in_wishlist === 1 ? (
                      <FaHeart className="wishlist-heart" />
                    ) : (
                      <FaRegHeart className="wishlist-heart" />
                    )}
                  </div>
                </div>
                <div className="saree-card-title">{product.product_name}</div>
                <div className="saree-card-price">
                  <span>₹ {product.price}</span>
                  <span style={{ float: "right" }} className="saree-rate">
                    <img src={star} alt="Rating" />
                    {product.average_rating}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* modal code */}
        <div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="addModalheader"></Modal.Header>
            <Modal.Body>
              <div className="successImg">
                <img src={successImg} />
              </div>
              <h3 style={{ textAlign: "center" }}>Added to Cart</h3>
            </Modal.Body>
          </Modal>
        </div>
        {/* customer review */}
        <div>
          <div className="customer-title">Customer Reviews (24)</div>
          <div className="customer-part">
            {customer.map((item) => (
              <div className="customer-subpart">
                <div className="customer-desc">
                  <div>
                    <span className="customer-star">
                      <FaStar />
                    </span>
                    <span>{item.rate}</span>
                  </div>
                  <div>{item.desc}</div>
                </div>
                <div className="customer-name">
                  <div>&nbsp;</div>
                  <div>
                    <span>{item.name}</span>
                    <span style={{ color: "gray" }}>
                      <FaGripLinesVertical />
                    </span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="view-text">View all reviews</div>
        </div>
        <div>
          <Mail />
        </div>
      </div>
    </>
  );
}
